import './component';
import './preview';

Shopware.Service('cmsService').registerCmsBlock({
    name: 'acris-faq',
    label: 'acris-faq.blocks.bundle.faq.label',
    category: 'acris-faq',
    component: 'sw-cms-block-acris-faq',
    previewComponent: 'sw-cms-preview-acris-faq',
    defaultConfig: {
        marginBottom: '20px',
        marginTop: '20px',
        marginLeft: '20px',
        marginRight: '20px',
        sizingMode: 'boxed'
    },
    slots: {
        column: {
            type: 'acris-faq'
        }
    }
});
